import styled from "styled-components";

import { variant } from "styled-system";

export const Input = styled("input")(
  {
    borderRadius: "4px",
    border: "solid 1px #e6e8f0",
    backgroundColor: "#fafbfc",
    fontSize: "14px",
    color: "#222939",
    padding: "8px",
    width: "100%",
    transition: "all 0.08s ease-out",
    "&::placeholder": {
      lineHeight: "1.71",
      color: "#6f7582"
    },
    "&:focus": {
      outline: "unset",
      borderColor: "#bab1ff",
      boxShadow: "0 0 0px 2pt rgba(186,177,255,0.3)"
    }
  },
  variant({
    variants: {
      extraBig: {
        height: "59px",
        "@media screen and (max-width: 426px)": {
          height: "42px"
        }
      },
      big: {
        height: "40px"
      },
      default: {
        height: "32px"
      }
    }
  })
);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/spocketUI/components/Input.js